'use client'

import { useEffect } from 'react'
 
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // CRITICAL: NO exponer digest en producción - puede contener secrets
    if (process.env.NODE_ENV === 'development') {
      console.error('Error details:', error.message)
    } else {
      // Solo loguear mensaje genérico en producción
      console.error('Application error occurred')
    }
  }, [error])
 
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-4">¡Algo salió mal!</h2>
        <p className="text-gray-600 mb-4">Se produjo un error inesperado.</p>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={() => reset()}
        >
          Intentar de nuevo
        </button>
      </div>
    </div>
  )
}